import React from 'react';
export function GuaranteeSection() {
  return <section className="py-6 px-4 bg-blue-50" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <div className="bg-white p-5 rounded-lg shadow-2xl border-4 border-blue-500" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-4 text-blue-600" data-id="element-127">
            🛡️ GARANTÍA TOTAL
          </h2>

          <div className="text-center mb-4" data-id="element-128">
            <p className="text-2xl mb-2" data-id="element-129">Tienes 7 días para probarlo.</p>
            <p className="text-2xl mb-2" data-id="element-130">Si no te sirve:</p>
            <p className="text-3xl font-bold text-green-600 mb-2" data-id="element-131">
              👉 Te devolvemos el dinero.
            </p>
            <p className="text-xl font-bold" data-id="element-132">Sin preguntas.</p>
          </div>
        </div>
      </div>
    </section>;
}
export default GuaranteeSection;